var exports = {
  "Lw": "VoiceSceneOverlay.module__overlay___R21HcV",
  "WY": "VoiceSceneOverlay.module__nonCameraLayer___R21HcV",
  "Y3": "VoiceSceneOverlay.module__anchor___R21HcV",
  "my": "VoiceSceneOverlay.module__avatar___R21HcV",
  "JA": "VoiceSceneOverlay.module__standing___R21HcV",
  "xL": "VoiceSceneOverlay.module__marker___R21HcV",
  "Vc": "VoiceSceneOverlay.module__markerTable___R21HcV",
  "cK": "VoiceSceneOverlay.module__markerWatch___R21HcV",
  "Fr": "VoiceSceneOverlay.module__tableLabel___R21HcV",
  "vz": "VoiceSceneOverlay.module__backToTable___R21HcV",
  "ju": "VoiceSceneOverlay.module__overflow___R21HcV",
  "W_": "VoiceSceneOverlay.module__poster___R21HcV",
  "AF": "VoiceSceneOverlay.module__posterWho___R21HcV",
  "vO": "VoiceSceneOverlay.module__posterName___R21HcV",
  "EE": "VoiceSceneOverlay.module__posterLive___R21HcV",
  "sr": "VoiceSceneOverlay.module__voiceScenePosterLive___R21HcV",
  "nj": "VoiceSceneOverlay.module__screen___R21HcV",
  "aq": "VoiceSceneOverlay.module__screenVideo___R21HcV",
};

module.exports = exports;
